__turbopack_context__.v({
  "content": "indeed-cta-module-scss-module__3rAVnW__content",
  "cta": "indeed-cta-module-scss-module__3rAVnW__cta",
  "ctaButton": "indeed-cta-module-scss-module__3rAVnW__ctaButton",
  "divider": "indeed-cta-module-scss-module__3rAVnW__divider",
  "imageSection": "indeed-cta-module-scss-module__3rAVnW__imageSection",
  "img": "indeed-cta-module-scss-module__3rAVnW__img",
  "indeed_cta_background": "indeed-cta-module-scss-module__3rAVnW__indeed_cta_background",
  "indeed_cta_container": "indeed-cta-module-scss-module__3rAVnW__indeed_cta_container",
  "indeed_cta_layout": "indeed-cta-module-scss-module__3rAVnW__indeed_cta_layout",
  "indeed_logo": "indeed-cta-module-scss-module__3rAVnW__indeed_logo",
  "leftShape": "indeed-cta-module-scss-module__3rAVnW__leftShape",
  "logos": "indeed-cta-module-scss-module__3rAVnW__logos",
  "personImage": "indeed-cta-module-scss-module__3rAVnW__personImage",
  "rightShape": "indeed-cta-module-scss-module__3rAVnW__rightShape",
  "textSection": "indeed-cta-module-scss-module__3rAVnW__textSection",
  "title": "indeed-cta-module-scss-module__3rAVnW__title",
  "udemy_logo": "indeed-cta-module-scss-module__3rAVnW__udemy_logo",
});
